



















































import * as Sentry from "@sentry/browser";
import { firestore} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { auth } from "@/scripts/firebase"
import { Component,Mixins} from "vue-property-decorator"
import { ValidationObserver } from 'vee-validate'
import Notice from "@/components/Notice.vue"
import Common from '@/mixins/common';

/**
 * userデータ検証入れる
 */

@Component({
  components: {
    Notice,
  }
})

export default class SignIn extends Mixins(Common) {
  password = '';
  email = '';
  isLoading = false
  notice: NoticeProps = {}

  get observer(){
    return this.$refs.signInValidationObserver as InstanceType<typeof ValidationObserver>
  }

  async created(){
    console.trace('created')
  }

  destroyed() {
    console.trace('destroyed')
  }

  public async signIn() {

		try{
			this.notice = {
				isShow: false,
			}
		
		if(await this.observer.validate()){
			

			this.$store.commit("setLoading",true);
			this.isLoading = true
			
      await auth.signInWithEmailAndPassword(this.email , this.password);

			if(auth.currentUser){
				await auth.currentUser.getIdToken(true)

				if(auth.currentUser.emailVerified ){
					this.notice = {
						message: this.$t('signIn.success') as string,
            isShow: true,
            duration: 0,
						type: {'is-success': true}
					}
					const userDocRef = this.$getUserPrivateProfileDocRef()
					const data = {
						lastSignInTime: firestore.FieldValue.serverTimestamp()
          }
          console.log(userDocRef.path)
					await this.$updateDoc(userDocRef,data)

					/**
					 * ログイン後自動転送 転送先は変更する予定
					 */
					//this.$router.push('/user/profile');
				}else{
					await auth.currentUser.sendEmailVerification()
					this.notice = {
						message: this.$t('signIn.emailVerification') as string,
            isShow: true,
            duration: 0,
            type: {'is-info': true}
					}
					await auth.signOut()
					console.log('Logout');
        }
        
        this.email = '';
        this.password = '';
        this.observer.reset()
      }
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('signIn.error') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)
      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){        
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
